import { render, staticRenderFns } from "./portworxVolume.vue?vue&type=template&id=ac8f30dc&"
import script from "./portworxVolume.vue?vue&type=script&lang=js&"
export * from "./portworxVolume.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports